import { render, staticRenderFns } from "./Comp63t2.vue?vue&type=template&id=a0197c54&scoped=true&"
import script from "./Comp63t2.vue?vue&type=script&lang=js&"
export * from "./Comp63t2.vue?vue&type=script&lang=js&"
import style0 from "./Comp63t2.vue?vue&type=style&index=0&id=a0197c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0197c54",
  null
  
)

export default component.exports